"use client";
import cn from "clsx";
import { useTranslations } from "next-intl";
import { Skeleton } from "@radix-ui/themes";
import { DataInputParams } from "./inputType";
import { Form, Rate, Skeleton as AntSkeleton, Button } from "antd";
import { checkDisabled, checkNoItem, GetDataInputElement } from "./inputFunction";
import { TransitionType } from "@/components/layout/layoutType";
import { getInput as getInputNumber } from "./inputNumber";
import { Debug } from "@/util/debug";
import { useState } from "react";

import Icon from "@/components/common/icon/icon";
// import dynamic from "next/dynamic";
// const Icon = dynamic(() => import("@/components/common/icon/icon"), { ssr: false });
export const getInputRate = (t: TransitionType, params: DataInputParams) => {
  const disabled = checkDisabled(params);
  const value = params.inputMode == "view" && !(params.readInputDisabled ?? false) ? params.value : undefined;
  return (
    <Rate
      character={params.character ?? <Icon iconType="" iconName={params.iconName ?? "Coffee"} weight="bold" />}
      className={cn(params.inputClassName, "inputRate")}
      style={params.inputStyle}
      value={value}
      //defaultValue={params.value}
      allowClear={params.allowClear ?? true}
      allowHalf={params.allowHalf}
      disabled={disabled}
      id={params.name}
      count={params.maxValue ? Number(params.maxValue) : 5}
      onChange={params.onChange}
    />
  );
};

export default function DataInputNumber(params: DataInputParams) {
  const t = useTranslations(params.transitionGroup ?? "contents");
  const prev = params.prev ? GetDataInputElement(params.prev, false, params.values, t) : undefined;
  const next = params.next ? GetDataInputElement(params.next, true, params.values, t) : undefined;
  const inputPrev = params.inputPrev ? GetDataInputElement(params.inputPrev, false, params.values, t) : undefined;
  const inputNext = params.inputNext ? GetDataInputElement(params.inputNext, true, params.values, t) : undefined;
  const maxValue = params.maxValue !== undefined ? Number(params.maxValue) : 5;
  const minValue = params.maxValue !== undefined ? Number(params.minValue) : 0;
  const disabled = checkDisabled(params);
  const [sync, setSync] = useState(false);
  if (params.formFunction && params.name) {
    if (!params.formFunction[params.name]) {
      params.formFunction[params.name] = {};
    }
    params.formFunction[params.name]["inputSync"] = () => {
      if (params.form) {
        if (!sync) {
          setSync(true);
          const setValues: Record<string, any> = {};
          setValues[params.name + "_inputNumber"] = params.form.getFieldValue(params.name);
          params.form.setFieldsValue(setValues);
          setTimeout(() => setSync(false), 100);
        }
      }
    };
  }

  const onChange = (obj: any) => {
    Debug(obj);
    if (params.form) {
      const value = obj;
      const setValues: Record<string, any> = {};
      if (params.form && params.name) {
        if (params.nullValue !== undefined && obj === params.nullValue) {
          setValues[params.name] = null;
          setValues[params.name + "_inputNumber"] = null;
        } else {
          setValues[params.name] = value;
          setValues[params.name + "_inputNumber"] = value;
        }
      }
      params.form.setFieldsValue(setValues);
    }
    if (params.onChange) {
      params.onChange({ key: params.name, value: obj, name: params.subListName, index: params.index });
    }
  };
  const onChangeInput = (obj: any) => {
    Debug(obj);
    if (params.form) {
      const setValues: Record<string, any> = {};
      if (params.name) {
        if (params.nullValue !== undefined && obj.value === params.nullValue) {
          setValues[params.name] = null;
          setValues[params.name + "_inputNumber"] = null;
        } else {
          setValues[params.name] = obj.value;
          setValues[params.name + "_inputNumber"] = obj.value;
        }
        params.form.setFieldsValue(setValues);
      }
    }
    if (params.onChange) {
      params.onChange(obj);
    }
  };
  const minButton =
    !disabled && params.minButton ? (
      <Button
        {...params.minButton}
        onClick={
          minValue !== null && minValue !== undefined
            ? (e) => {
                onChange({ key: params.name, value: minValue ? Number(minValue) : 0, index: params.index });
                params.minButton?.onClick ? params.minButton?.onClick(e) : undefined;
              }
            : undefined
        }
      />
    ) : undefined;
  const maxButton =
    !disabled && params.maxButton ? (
      <Button
        {...params.maxButton}
        onClick={
          maxValue !== null && maxValue !== undefined
            ? (e) => {
                onChange({ key: params.name, value: maxValue, index: params.index });
                params.maxButton?.onClick ? params.maxButton?.onClick(e) : undefined;
              }
            : undefined
        }
      />
    ) : undefined;

  const mergeParams = { ...params, onChange: onChange, minValue: 0, maxValue: maxValue };
  const inputNumber =
    params.inputType === "rateInput"
      ? getInputNumber(t, {
          ...mergeParams,
          inputClassName: params.inputNumberClassName ?? "ml-3",
          step: params.allowHalf ? 0.5 : 1,
          onChange: onChangeInput,
        })
      : "";
  return (
    <>
      {prev}
      {checkNoItem(params) ? (
        <>
          {inputPrev}
          {minButton}
          {getInputRate(t, params)}
          {maxButton}
          {inputNext}
          {inputNumber}
        </>
      ) : (
        <>
          {inputPrev}
          {minButton}
          <Form.Item name={params.name} noStyle initialValue={params.value ?? params.defaultValue}>
            {getInputRate(t, mergeParams)}
          </Form.Item>
          {maxButton}
          {inputNext}
          {params.inputType === "rateInput" ? (
            <Form.Item
              name={params.name + "_inputNumber"}
              noStyle
              initialValue={params.value ?? params.defaultValue}
              required={params.required}
            >
              {inputNumber}
            </Form.Item>
          ) : (
            ""
          )}
        </>
      )}
      {next}
    </>
  );
}
